// extracted by mini-css-extract-plugin
module.exports = {"form":"MarketForm_form__NR0mL","noteField":"MarketForm_noteField__ecSGs"};